export default function setIsNewPage() {
    return async (ctx) => {
        ctx.data = {
            ...ctx.data,
            isNewPage: true,
        };
    };
}
